// O que cada opcao da impressora faz de verdade no app de impressao (exe), com exemplo do que sai
// no papel. Levantado do codigo do exe (frmPrincipalNovo.processarImpressao, PrinterDAL,
// PedidoDAL, MesaDAL, CaixaDAL). Se o exe mudar, revisar aqui.

const CUPOM_PEDIDO = `----------------------------------------
             PIZZARIA DO ZE
----------------------------------------
17-10-2026 19:42              cod.: 1234
----------------------------------------
ENTREGA - 523
----------------------------------------
                CLIENTE
JOAO DA SILVA
RUA DAS FLORES, 120 - CENTRO
Fone: 19999990000
----------------------------------------
                 ITENS
----------------------------------------
PIZZA GRANDE
 BORDA CATUPIRY
 - Sabor 1: CALABRESA
   [REMOVER ] CEBOLA
 - Sabor 2: MUSSARELA
  Qtd.: 1 x R$59,90              R$59,90
........................................
----------------------------------------
Subtotal                        R$ 73,90
Entrega                          R$ 8,00
Total                           R$ 81,90
----------------------------------------
           FORMA DE PAGAMENTO
Dinheiro.: 100,00
Troco....: 18,10
----------------------------------------
Operador                           MARIA`;

export const AJUDA = {
  senhas: {
    titulo: "Senha",
    resumo: "Imprime a senha (ficha) que o cliente recebe.",
    detalhes: [
      "Sai nos pedidos de BALCÃO. Na mesa, só se a empresa estiver configurada para imprimir senha por pedido.",
      "O formato é escolhido em “Tipo de senha”.",
      "Não é filtrada por grupo de produto nem por tipo de entrega: sai com todos os itens.",
    ],
    exemplos: [
      {
        titulo: "Somente Senha",
        texto: `SEN. 523          (letra grande)
17/10/2026 19:52
Operador: MARIA`,
      },
    ],
  },
  tipoSenha: {
    titulo: "Tipo de senha",
    resumo: "Formato da senha impressa (vale só com “Senha” ligado).",
    detalhes: [
      "Somente Senha: só o número em letra grande, sem itens. O horário impresso é o do pedido + 5 minutos.",
      "Itens Pedido: o número e a lista de todos os itens, sem cliente e sem total.",
      "Senha Por Item: uma senha para cada unidade (2 x X-Burguer = 2 senhas), cada uma com um ID para conferência.",
    ],
    exemplos: [
      { titulo: "Somente Senha", texto: `SEN. 523          (letra grande)
17/10/2026 19:52
Operador: MARIA` },
      {
        titulo: "Itens Pedido",
        texto: `SEN.: 523
----------------------------------------
                 ITENS
----------------------------------------
 - X-BURGUER
  Qtd.: 2 x R$25,00              R$50,00
........................................
 - COCA LATA
  Qtd.: 1 x R$6,00                R$6,00
----------------------------------------`,
      },
      {
        titulo: "Senha Por Item (uma por unidade)",
        texto: `SEN.: 523
----------------------------------------
 - X-BURGUER
  Qtd.: 1 x R$25,00              R$25,00
----------------------------------------
ID: 1234-2
(2 de 3)`,
      },
    ],
  },
  pedidos: {
    titulo: "Pedidos",
    resumo: "Imprime a via do pedido (produção/conferência): balcão, entrega, buscar e mesa.",
    detalhes: [
      "Só saem os itens dos grupos marcados em “Categorias / Grupo de Produto”. Se nenhum item do pedido for desses grupos, nada sai (ex.: bebidas só no bar, pizzas só na cozinha).",
      "Balcão, entrega e buscar: o caixa precisa estar marcado em “Caixas” e o tipo em “Tipo de Entrega”. Pedido de mesa depende só de “Caixas”.",
      "Também reimprime só o item alterado quando muda a quantidade na mesa.",
      "Sai com preços e forma de pagamento (na mesa, sem cliente e sem totais).",
    ],
    exemplos: [{ titulo: "Via do pedido", texto: CUPOM_PEDIDO }],
  },
  online: {
    titulo: "Online",
    resumo: "Pedidos do iFood/OnPedido saem nesta impressora mesmo sem itens dos grupos dela.",
    detalhes: [
      "Só funciona junto com “Pedidos”.",
      "Use na impressora que precisa receber todo pedido do iFood, mesmo que os itens sejam de outra impressora.",
      "O bloco do iFood (SISTEMA / ID) aparece em qualquer via de pedido iFood, com ou sem esta opção.",
      "Não tem relação com pagamento online.",
    ],
    exemplos: [
      {
        titulo: "Bloco que aparece nos pedidos do iFood",
        texto: `                 ITENS
----------------------------------------
SISTEMA: IFOOD
ID. SISTEMA..: 7781
 - 1 x COMBO SMASH
----------------------------------------`,
      },
    ],
  },
  caixas: {
    titulo: "Fech. Caixa",
    resumo: "Imprime o fechamento de caixa e a fita de caixa.",
    detalhes: [
      "Sai quando o caixa é fechado ou quando pedem a fita (resumo por forma de pagamento, sangrias e entregas por motoboy).",
      "Recebe só dos caixas marcados em “Caixas”.",
    ],
    exemplos: [
      {
        titulo: "Fechamento",
        texto: `           CONTROLE DE CAIXA
                CAIXA 1
________________________________________
Data do Caixa: 17/10/2026
Operador: MARIA
________________________________________
           VALORES INFORMADOS
Aberto:                        R$ 100,00
Dinheiro:                      R$ 842,50
Cartao:                      R$ 1.230,00
                ATENCAO
        Esta faltando: R$ -12,50`,
      },
    ],
  },
  mesa_conta: {
    titulo: "Mesas - Conta",
    resumo: "Imprime a conta da mesa ou da comanda quando pedem a conta.",
    detalhes: [
      "A conta chega pelo caixa 5 (mesas). Ligar esta opção faz a impressora receber tudo que vier do caixa 5, mesmo sem marcá-lo em “Caixas”. Se “Pedidos” também estiver ligado, pedidos de mesa desse caixa também saem aqui.",
      "Lista todos os itens da mesa (não filtra por grupo), taxa de serviço, desconto, pagamentos e divisão por pessoa.",
    ],
    exemplos: [
      {
        titulo: "Conta da mesa",
        texto: `                 RESUMO
........................................
MESA 05                 17/10/2026 21:15
........................................
  - PIZZA CALABRESA | MUSSARELA
                       1 X 59,90 = 59,90
________________________________________
Sub-total                          73,90
Taxa Servico                10% - 7,39
Total                              81,29
Pago                               20,00
Restante                           61,29
Dividido por pessoa: 40,65`,
      },
    ],
  },
  controleEntregas: {
    titulo: "Entrega",
    resumo: "Imprime uma via resumida dos pedidos de ENTREGA, para o controle do motoboy.",
    detalhes: [
      "Sai só em pedidos de ENTREGA que não foram pagos online.",
      "Os itens saem resumidos por grupo (bebidas detalhadas), só dos grupos marcados.",
      "Sozinha não imprime: a impressora precisa ter também Senha, Pedidos, Fech. Caixa ou Mesas - Conta ligado.",
    ],
    exemplos: [
      {
        titulo: "Via de controle de entrega",
        texto: `ENTREGA - 523
----------------------------------------
JOAO DA SILVA
RUA DAS FLORES, 120 - CENTRO
----------------------------------------
                 ITENS
----------------------------------------
2 x PIZZAS
1 x BEBIDAS
  2 x COCA-COLA 2L
----------------------------------------
Total                           R$ 81,90
           FORMA DE PAGAMENTO
Dinheiro.: 100,00`,
      },
    ],
  },
  confirmacaoSaida: {
    titulo: "Confirm. Saída",
    resumo: "Imprime o comprovante de saída de um item da comanda (ex.: chopp entregue), um por unidade.",
    detalhes: [
      "Chega pelo caixa 5, como a conta da mesa (vale o mesmo aviso de “Mesas - Conta”).",
      "Sozinha não imprime: a impressora precisa ter também Senha, Pedidos, Fech. Caixa ou Mesas - Conta ligado.",
    ],
    exemplos: [
      {
        titulo: "Comprovante (um por unidade)",
        texto: `CONFIRMACAO       (letra grande)
SAIDA
17/10/2026 21:20
CHOPP 300ML
Conta n.: 845
JOAO
Item: 1`,
      },
    ],
  },
  ingredientes: {
    titulo: "Imprimir Ingredientes",
    resumo: "Acrescenta a lista de ingredientes de cada sabor na via do pedido.",
    detalhes: [
      "Vale na via de Pedidos e na senha com itens (Itens Pedido / Senha Por Item).",
      "Adicionar e remover ingrediente ([ADICIONAR ] / [REMOVER ]) sai sempre, com ou sem esta opção.",
    ],
    exemplos: [
      { titulo: "Desligado", texto: ` - Sabor 1: CALABRESA
   [REMOVER ] CEBOLA` },
      {
        titulo: "Ligado",
        texto: ` - Sabor 1: CALABRESA
Ingredientes: MUSSARELA, CALABRESA, CEBOLA,
   [REMOVER ] CEBOLA`,
      },
    ],
  },
  exibe_taxa_entrega: {
    titulo: "Esconder taxa de entrega",
    resumo: "Em pedidos de ENTREGA, tira as linhas Subtotal e Entrega do rodapé; fica só o Total.",
    detalhes: ["O Total continua com a taxa incluída.", "Vale na via de Pedidos e na de Entrega."],
    exemplos: [
      { titulo: "Desligado", texto: `Subtotal                        R$ 73,90
Entrega                          R$ 8,00
Total                           R$ 81,90` },
      { titulo: "Ligado", texto: `Total                           R$ 81,90` },
    ],
  },
  tiposEntrega: {
    titulo: "Tipo de Entrega",
    resumo: "Quais pedidos de balcão, buscar e entrega saem na via de Pedidos.",
    detalhes: [
      "Nenhum marcado = nenhum pedido de balcão/buscar/entrega sai nesta impressora.",
      "Pedidos de mesa não dependem disto (só de “Caixas”). Senha, conta e controle de entrega também não.",
    ],
  },
  caixasLista: {
    titulo: "Caixas",
    resumo: "De quais caixas esta impressora recebe impressões.",
    detalhes: [
      "Ex.: impressora do caixa 1 marca só o caixa 1 para não imprimir o que é lançado no caixa 2.",
      "Nenhum marcado = recebe de todos os caixas, mas os pedidos de balcão/buscar/entrega deixam de sair.",
      "O caixa 5 (mesas) entra sozinho quando “Mesas - Conta” ou “Confirm. Saída” estão ligados.",
    ],
  },
  grupos: {
    titulo: "Categorias / Grupo de Produto",
    resumo: "Quais itens saem nas vias de Pedidos e de Entrega desta impressora.",
    detalhes: [
      "Item de grupo não marcado não sai aqui (ex.: na cozinha, marque pizzas e lanches; no bar, só bebidas).",
      "Nenhum marcado = Pedidos e Entrega não imprimem nada (exceto iFood com “Online”).",
      "Senha, conta, fechamento e confirmação de saída não são filtrados por grupo.",
    ],
  },
  colunas: {
    titulo: "Colunas",
    resumo: "Quantos caracteres cabem numa linha do papel.",
    detalhes: [
      "Bobina 80mm: normalmente 40 a 48. Bobina 58mm: 32.",
      "Linhas tracejadas quebrando = número alto demais; sobrando espaço à direita = número baixo.",
      "Não afeta a senha “Somente Senha”, a confirmação de saída nem o fechamento de caixa (que usa 40).",
    ],
    exemplos: [
      { titulo: "40 colunas", texto: `----------------------------------------
Total                           R$ 81,90` },
      { titulo: "32 colunas", texto: `--------------------------------
Total                   R$ 81,90` },
    ],
  },
};

// Opcoes que fazem a impressora receber/imprimir algo. Sem nenhuma delas o exe nao imprime
// nada (nem Entrega / Confirm. Saida / Online sozinhas).
export const OPCOES_PRINCIPAIS = ["senhas", "pedidos", "caixas", "mesa_conta"];

export const TIPOS_IMPRESSAO = [
  "senhas",
  "pedidos",
  "online",
  "caixas",
  "mesa_conta",
  "controleEntregas",
  "confirmacaoSaida",
  "ingredientes",
];

// Avisos de configuracao que na pratica nao imprime o que parece.
export const avisos = (imp) => {
  const t = imp.tipo || {};
  const lista = [];
  const principal = OPCOES_PRINCIPAIS.some((k) => t[k]);
  if (!principal && (t.controleEntregas || t.confirmacaoSaida || t.online || t.ingredientes)) {
    lista.push("Nada vai sair: Entrega, Confirm. Saída e Online só funcionam com Senha, Pedidos, Fech. Caixa ou Mesas - Conta ligado.");
  } else if (!principal) {
    lista.push("Nenhuma opção de impressão ligada: esta impressora não imprime nada.");
  }
  if (t.online && !t.pedidos) lista.push("“Online” só funciona junto com “Pedidos”.");
  if ((t.pedidos || t.controleEntregas) && !(imp.grupoProdutos || []).length) {
    lista.push("Nenhum grupo de produto marcado: as vias de Pedidos e de Entrega não imprimem nada.");
  }
  if (t.pedidos && !(imp.tiposEntrega || []).length) {
    lista.push("Nenhum tipo de entrega marcado: pedidos de balcão/buscar/entrega não saem (mesa sai).");
  }
  if (t.pedidos && !(imp.caixas || []).length) {
    lista.push("Nenhum caixa marcado: recebe de todos os caixas, mas pedidos de balcão/buscar/entrega não saem.");
  }
  return lista;
};

// O que a impressora imprime, em frases curtas (para o card da lista).
export const resumo = (imp, nomeCaixas) => {
  const t = imp.tipo || {};
  const partes = [];
  if (t.senhas) partes.push(`senhas (${imp.tipoSenha || "Somente Senha"})`);
  if (t.pedidos) {
    // MESA em Tipo de Entrega nao muda nada: pedido de mesa sai sempre (depende so de Caixas).
    const tipos = (imp.tiposEntrega || []).filter((x) => x !== "MESA").map((x) => x.toLowerCase());
    const de = tipos.length ? `${tipos.join(", ")} e mesa` : "só mesa";
    partes.push(`pedidos (${de}; ${(imp.grupoProdutos || []).length} grupos)${t.online ? " + todo pedido iFood" : ""}`);
  }
  if (t.controleEntregas) partes.push("via de controle de entrega");
  if (t.mesa_conta) partes.push("conta da mesa/comanda");
  if (t.confirmacaoSaida) partes.push("confirmação de saída");
  if (t.caixas) partes.push("fechamento e fita de caixa");
  if (!partes.length) return "Não imprime nada.";
  return `Imprime ${partes.join(", ")} — caixas: ${nomeCaixas}.`;
};
